import { GsResponse, RawResponse, toGsResponse } from '../goodstack'

import { MutationFn } from '@percent/workplace-giving/common/hooks/useMutation/useMutation.types'
import { NonprofitRequestProps, NonprofitRequestResponse } from './createNonprofitRequest.types'

export const createNonprofitRequest: MutationFn<NonprofitRequestProps, GsResponse<NonprofitRequestResponse>> = async (
  client,
  { organisationDetails }
) => {
  const res = await client.post<RawResponse<NonprofitRequestResponse>>(
    'v1/workplace/organisations',
    {
      organisationDetails
    },
    {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    }
  )

  return toGsResponse(res.status, res.data)
}
